import { connect } from 'react-redux';

import { resetPassword, setMessage } from '../actions/userActions';
import ResetPasswordView from '../components/User/ResetPassword/resetPasswordView.jsx';
import {
  getErrors,
  getLoading,
  getMessage,
  getSuccessful,
} from '../components/User/userSelectors';

const mapStateToProps = (state) => ({
  errors: getErrors(state),
  successful: getSuccessful(state),
  message: getMessage(state),
  isLoading: getLoading(state),
});

const mapDispatchToProps = (dispatch) => ({
  resetPassword: (password, confirmPassword, token) => {
    dispatch(resetPassword(password, confirmPassword, token));
  },
  setMessage: (value) => {
    dispatch(setMessage(value));
  },
});

const ResetPasswordContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResetPasswordView);

export default ResetPasswordContainer;
